import debounce from 'lodash/debounce'

export const initSearchBar = () => {
    const SEARCH_DEBOUNCE_MS = 400;
    const SEARCH_CHAR_MIN_LENGTH = 2;

    const searchInputEl = document.getElementById("searchInput");
    const searchResultsEl = document.getElementById("searchResults");
    const searchDropdownMenuEl = document.getElementById("searchDropdownMenu");
    const loadingSpinnerEl = document.getElementById("searchLoadingSpinner");

    if (!searchInputEl || !searchResultsEl || !searchDropdownMenuEl || !loadingSpinnerEl) {
        console.warn("One of the elements needed for searchbar was not found. Cannot initialize search bar.");
        return;
    }

    const debouncedSearchFn = debounce(runSearch, SEARCH_DEBOUNCE_MS);

    searchInputEl.addEventListener('focus', async (e) => {
        if (searchInputEl.value.length >= SEARCH_CHAR_MIN_LENGTH) {
            openDropdown();
        }
    });

    searchInputEl.addEventListener('input', async (e) => {
        debouncedSearchFn(e.target.value);
    });

    searchInputEl.addEventListener('keydown', async (e) => {
        if (e.key === 'Enter' || e.key === 'NumEnter') {
            hideDropdown();
        }
    });

    function toggleLoading(show) {
        if (show) {
            loadingSpinnerEl.classList.remove('d-none');
        } else {
            loadingSpinnerEl.classList.add('d-none');
        }
    }

    function openDropdown() {
        searchDropdownMenuEl.classList.add('show');
    }

    function hideDropdown() {
        searchResultsEl.innerHTML = '';
        debouncedSearchFn.cancel();
        searchDropdownMenuEl.classList.remove('show');
    }

    async function runSearch(searchPhrase) {
        if (searchPhrase.length < SEARCH_CHAR_MIN_LENGTH) {
            hideDropdown();
            return;
        }

        toggleLoading(true);
        openDropdown();

        try {
            let action = searchInputEl.getAttribute('data-search-action');
            action += '?q=' + encodeURIComponent(searchPhrase);

            const result = await fetch(action, {
                method: "GET",
                headers: {"X-Requested-With": "XMLHttpRequest"}
            });

            if (result.ok) {
                searchResultsEl.innerHTML = await result.text();
                openDropdown();
            }
        } catch (e) {
            console.error("Error during search bar request:", e);
        } finally {
            toggleLoading(false);
        }
    }
}